// TODO: 研究可不可以這裡不 import moment
import moment from 'moment-timezone'
import i18n from '@/lang'
import cloneDeep from 'lodash.clonedeep'
import {
  operationSelector as staticOperationSelector,
  materialType as staticMaterialType,
  allogeneicMaterialType as staticAllogeneicMaterialType
} from '@/util/PHISelector.js'
import {
  getPatientProfile as GET_PATIENT_PROFILE
} from '@/api/patient/profile.js'
import {
  getAllRecord as GET_ALL_RECORD
} from '@/api/patient/record.js'
import {
  getKSQList as GET_KSQ_LIST
} from '@/api/patient/ksq.js'
import { DEFAULT_TIMEZONE } from '@/util/helper'

const getDefaultState = () => (
  {
    userInfo: {
      id: '',
      name: '',
      birthdate: '',
      age: 0,
      avatar: '',
      gender: '',
      managements: [], // 應該是 {}
      affectiveSide: 'left',
      isLock: false,
      lockTime: 0,
      lv: 0,
      isRental: false,
      isRentalEnd: false,
      timezone: DEFAULT_TIMEZONE,
      scheduleStarted: false,
      scheduleId: null,
      medicalPersonnel: {
        id: '',
        name: '',
        avatar: '',
        type: 0
      },
      device: {
        deviceName: '',
        lotNumber: '',
        mac: '',
        pin: '',
        recycleDuration: 0,
        rentalEndTime: 0,
        rentalStatus: 0,
        sn: '',
        token: ''
      },
      painFeedbackLockId: ''
    },

    operation: {
      id: '',
      loadedTime: 0,
      affectiveSide: 0,
      date: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        date: new Date().getDate()
      },
      hospital: '',
      managements: [],
      intervention: {
        hasIntervention: false,
        list: []
      },
      angleLimit: [],
      weightLimit: [],
      otherLimit: [],
      previousInjury: {
        injury: false,
        area: '',
        management: '',
        year: 0,
        month: 0
      },
      previousSurgery: {
        surgery: false,
        year: 0,
        month: 0,
        surgeon: '',
        hospital: '',
        managements: []
      }
    },

    profile: {
      firstName: '',
      lastName: '',
      phone: '',
      gender: null,
      birthday: '',
      height: 0,
      weight: 0,
      address: '',
      emergencyContact: '',
      emergencyPhone: '',
      kneepadFactory: '',
      injuryDate: '',
      injuryReason: ''
    },

    record: {
      id: '',
      loadedTime: 0,
      data: {}
    },

    score: {
      id: '',
      loadedTime: 0,
      scoreList: [
      ]
    },
    connectionTemplate: {
      id: '',
      patientId: '',
      advice: '',
      careTips: [],
      level: [],
      mustKnow: [],
      situations: [],
      isAutoUpgrade: false,
      updateTime: 0,
      assigner: {
        avatar: null,
        id: '',
        name: '',
        type: 0
      }
    }
  }
)

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  getters: {
    getUserInfo: state => {
      let info = JSON.parse(JSON.stringify(state.userInfo))
      info.legType = state.userInfo.affectiveSide
      info.affectiveSide = (state.userInfo.affectiveSide === 'left') ? i18n.t('formItemName.left') : i18n.t('formItemName.right')
      info.sameTimezone = state.userInfo.timezone === DEFAULT_TIMEZONE
      info.isSoftwareOnlyMode = state.userInfo.device.mac === '00:00:00:00:00:00'
      return info
    },
    getUserManagements: state => {
      let managements = state.userInfo.managements
      let fullManagements = ''
      const dictionary = {
        '前十字韌帶': i18n.t('operation.text.str_1'),
        '後十字韌帶': i18n.t('operation.text.str_2'),
        '外側副韌帶': i18n.t('operation.text.str_3'),
        '內側副韌帶': i18n.t('operation.text.str_4'),
        '外側半月板': i18n.t('operation.text.str_5'),
        '內側半月板': i18n.t('operation.text.str_6'),
        '其他': i18n.t('operation.text.str_7'),
        '重建': i18n.t('operation.text.str_8'),
        '修補': i18n.t('operation.text.str_9'),
        '保守治療 (自行填寫)': i18n.t('operation.text.str_10'),
        '自體': i18n.t('operation.text.str_11'),
        '異體': i18n.t('operation.text.str_12'),
        '人工': i18n.t('operation.text.str_13'),
        '膕膀肌肌腱': i18n.t('operation.text.str_14'),
        '髕骨韌帶': i18n.t('operation.text.str_15'),
        '其他 (自行填寫)': i18n.t('operation.text.str_16'),
        '阿基里斯腱': i18n.t('operation.text.str_17'),
        '帶骨韌帶': i18n.t('operation.text.str_18'),
        '切除': i18n.t('operation.text.str_19'),
        '移植': i18n.t('operation.text.str_20'),
        '保守治療': i18n.t('operation.text.str_21')
      }
      for (let key of Object.keys(managements)) {
        if (key === '其他') {
          fullManagements += dictionary['其他'] + '/'
          continue
        }

        let type = managements[key].split(' / ')
        if (i18n.locale !== 'en-US') {
          fullManagements += dictionary[key] + dictionary[type[0]] + '/'
        } else {
          fullManagements += `${dictionary[key]} ${dictionary[type[0]]}/`
        }
      }

      return fullManagements.substring(0, fullManagements.length - 1)
    },
    getOperationDate: state => {
      return state.operation.date
    }
  },
  mutations: {
    setUserId (state, id) {
      state.userInfo.id = id
    },
    setUserInfo (state, userInfo) {
      if (state.userInfo.id !== userInfo.id) return false
      state.userInfo = userInfo
    },
    syncLevelToSchedule (state, { index, level }) {
      if (index > state.schedule.level.length) return false
      state.schedule.level[index] = level
    },
    setOperationFromAPI (state, data) {
      let materialType = cloneDeep(staticMaterialType)

      let allogeneicMaterialType = cloneDeep(staticAllogeneicMaterialType)

      let op = {
        id: '',
        loadedTime: 0,
        affectiveSide: 0,
        date: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          date: new Date().getDate()
        },
        hospital: '',
        managements: [],
        intervention: {
          hasIntervention: false,
          list: []
        },
        angleLimit: [],
        weightLimit: [],
        otherLimit: [],
        previousInjury: {
          injury: false,
          area: '',
          management: '',
          year: 0,
          month: 0
        },
        previousSurgery: {
          surgery: false,
          year: 0,
          month: 0,
          surgeon: '',
          hospital: '',
          managements: []
        }
      }

      let patient = {
        firstName: '',
        lastName: '',
        phone: '',
        gender: null,
        birthday: '',
        height: 0,
        weight: 0,
        address: '',
        emergencyContact: '',
        emergencyPhone: '',
        kneepadFactory: '',
        injuryDate: '',
        injuryReason: ''
      }

      patient.phone = data.phone || ''
      patient.gender = data.gender || 0
      patient.birthday = data.birthday || ''
      if (data.detail != null) {
        patient.height = data.detail.height || 0
        patient.weight = data.detail.weight || 0
        patient.address = data.detail.address || ''
        patient.emergencyContact = data.detail.emergencyContact || ''
        patient.emergencyPhone = data.detail.emergencyPhone || ''
        patient.kneepadFactory = data.detail.kneepadFactory || ''
        patient.injuryDate = data.detail.injuryDate || ''
        patient.injuryReason = data.detail.injuryReason || ''
      }

      op.id = data.id
      op.affectiveSide = data.affectiveSide != null && data.affectiveSide.length > 0
        ? data.affectiveSide[0]
        : ''

      let dateArr = data.date.split('-')
      op.date.year = parseInt(dateArr[0])
      op.date.month = parseInt(dateArr[1])
      op.date.date = parseInt(dateArr[2])

      op.hospital = data.hospital

      let managements = []
      if (data.managements != null) {
        for (let key of Object.keys(data.managements).sort(sortManagement)) {
          let arg = {
            hover: false,
            show: {
              otherMenu: false,
              opMenu: false,
              conservative: false
            },
            step: 0,
            type: 0,
            text: key,
            value: true,
            way: ['', '', ''],
            wayType: [-255, -255, -255]
          }

          if (key.indexOf('韌帶') > -1) {
            arg.type = (key === '前十字韌帶') ? 1 : 3
            if (data.managements[key].indexOf('保守治療') > -1) {
              arg.show.conservative = true
              arg.step = 1
              arg.wayType[0] = 2
              arg.way[0] = data.managements[key]
            } else {
              let way = data.managements[key].split(' / ')
              if (way.length === 2) {
                arg.step = 1
                arg.wayType[0] = 1
                arg.wayType[1] = -1
                arg.way[0] = way[0]
                arg.way[1] = way[1]
              } else {
                arg.way[0] = way[0]
                arg.way[1] = way[1]
                arg.way[2] = way[2]

                arg.wayType[0] = 1
                arg.wayType[1] = 1

                let other = allogeneicMaterialType.findIndex(v => {
                  return v.text === arg.way[2]
                }) > -1

                other = other || materialType.findIndex(v => {
                  return v.text === arg.way[2]
                }) > -1

                arg.wayType[2] = !other ? 3 : -1
                arg.show.otherMenu = !other
                arg.step = !other ? 3 : 2
              }
            }
          } else if (key === '其他') {
            arg.wayType[0] = -1
            arg.way[0] = data.managements[key]
          } else if (key.indexOf('半月板') > -1) {
            arg.type = 2
            if (data.managements[key].indexOf('保守治療') > -1) {
              arg.show.conservative = true
              arg.step = 1
              arg.wayType[0] = 2
              arg.way[0] = data.managements[key]
            } else {
              arg.step = 0
              arg.wayType[0] = -1
              arg.way[0] = data.managements[key]
            }
          }

          managements.push(arg)
        }
      }

      op.managements = managements
      op.intervention.list = data.intervention
      op.intervention.hasIntervention = data.intervention != null && data.intervention.length > 0

      let angleLimit = []
      if (data.angleLimit != null) {
        for (let key of Object.keys(data.angleLimit)) {
          angleLimit.push({
            period: parseInt(key),
            angle: data.angleLimit[key]
          })
        }
      }

      let weightLimit = []

      if (data.weightLimit != null) {
        for (let key of Object.keys(data.weightLimit)) {
          weightLimit.push({
            period: parseInt(key),
            weight: data.weightLimit[key]
          })
        }
      }

      op.angleLimit = angleLimit
      op.weightLimit = weightLimit
      op.otherLimit = data.otherLimit

      let previousInjury = data.previousInjury != null
        ? data.previousInjury[0]
        : ''

      op.previousInjury.area = previousInjury.position
      op.previousInjury.year = previousInjury.date != null
        ? parseInt(
          previousInjury.date.split('/')[0]
        )
        : 1970
      op.previousInjury.month = previousInjury.date != null
        ? parseInt(
          previousInjury.date.split('/')[1]
        )
        : 1
      op.previousInjury.management = previousInjury.process

      op.previousInjury.injury = op.previousInjury.area !== '' ||
        op.previousInjury.year !== 0 ||
        op.previousInjury.month !== 0 ||
        op.previousInjury.management !== ''

      let previousSurgery = data.previousSurgery
      op.previousSurgery.year = parseInt(
        previousSurgery.date.split('/')[0]
      )
      op.previousSurgery.month = parseInt(
        previousSurgery.date.split('/')[1]
      )
      op.previousSurgery.hospital = previousSurgery.hospital
      op.previousSurgery.surgeon = previousSurgery.medicalName

      let pvManagements = []
      if (previousSurgery.position != null) {
        for (let key of Object.keys(previousSurgery.position).sort(sortManagement)) {
          let arg = {
            hover: false,
            show: {
              otherMenu: false,
              opMenu: false,
              conservative: false
            },
            step: 0,
            type: 0,
            text: key,
            value: true,
            way: ['', '', ''],
            wayType: [-255, -255, -255]
          }

          if (key.indexOf('韌帶') > -1) {
            arg.type = (key === '前十字韌帶') ? 1 : 3
            if (previousSurgery.position[key].indexOf('保守治療') > -1) {
              arg.show.conservative = true
              arg.step = 1
              arg.wayType[0] = 2
              arg.way[0] = previousSurgery.position[key]
            } else {
              let way = previousSurgery.position[key].split(' / ')
              if (way.length === 2) {
                arg.step = 1
                arg.wayType[0] = 1
                arg.wayType[1] = -1
                arg.way[0] = way[0]
                arg.way[1] = way[1]
              } else {
                arg.way[0] = way[0]
                arg.way[1] = way[1]
                arg.way[2] = way[2]

                arg.wayType[0] = 1
                arg.wayType[1] = 1

                let other = allogeneicMaterialType.findIndex(v => {
                  return v.text === arg.way[2]
                }) > -1

                other = other || materialType.findIndex(v => {
                  return v.text === arg.way[2]
                }) > -1

                arg.wayType[2] = !other ? 3 : -1
                arg.show.otherMenu = !other
                arg.step = !other ? 3 : 2
              }
            }
          } else if (key === '其他') {
            arg.wayType[0] = -1
            arg.way[0] = previousSurgery.position[key]
          } else if (key.indexOf('半月板') > -1) {
            arg.type = 2
            if (previousSurgery.position[key].indexOf('保守治療') > -1) {
              arg.show.conservative = true
              arg.step = 1
              arg.wayType[0] = 2
              arg.way[0] = previousSurgery.position[key]
            } else {
              arg.step = 0
              arg.wayType[0] = -1
              arg.way[0] = previousSurgery.position[key]
            }
          }

          pvManagements.push(arg)
        }
      }

      op.previousSurgery.managements = pvManagements
      op.previousSurgery.surgery =
        op.previousSurgery.hospital !== '' ||
        op.previousSurgery.surgeon !== '' ||
        op.previousSurgery.year !== 0 ||
        op.previousSurgery.month !== 0 ||
        op.previousSurgery.managements.length > 0

      op.loadedTime = new Date().getTime()

      state.operation = op
      state.profile = patient

      function sortManagement (a, b) {
        let managements = cloneDeep(staticOperationSelector)

        let aIndex = managements.findIndex(v => v.text === a)
        let bIndex = managements.findIndex(v => v.text === b)

        if (aIndex > bIndex) {
          return 1
        } else if (aIndex < bIndex) {
          return -1
        } else {
          return 0
        }
      }
    },
    setOperation (state, operation) {
      state.operation = operation
    },
    setRecord (state, record) {
      state.record = record
    },
    setScore (state, score) {
      state.score = score
    },
    setPatientProfile (state, profile) {
      state.profile = profile
    },
    setManagements (state, managements) {
      state.userInfo.managements = managements
    },
    userUnlock (state, id) {
      if (state.userInfo.id === id) {
        state.userInfo.isLock = false
      }
    },

    /* connection template */
    setConnectionTemplate (state, template) {
      state.connectionTemplate = {
        id: template.id,
        patientId: template.patientId,
        advice: template.advice,
        careTips: template.careTips,
        level: template.level,
        mustKnow: template.mustKnow,
        situations: template.situations,
        isAutoUpgrade: template.isAutoUpgrade || false,
        updateTime: template.updateTime,
        assigner: template.assigner
      }
    },
    setConnectionTemplateEmpty (state) {
      state.connectionTemplate = {
        id: '',
        patientId: '',
        advice: '',
        careTips: [],
        level: [],
        mustKnow: [],
        situations: [],
        isAutoUpgrade: false,
        assigner: {
          avatar: null,
          id: '',
          name: '',
          type: 0
        }
      }
    },
    syncLevelToTemplate (state, { index, level }) {
      if (index > state.connectionTemplate.level.length) return false
      state.connectionTemplate.level[index] = level
    },

    setPatientScheduleWithKeys (state, schedule) {
      for (let key of Object.keys(schedule)) {
        state.schedule[key] = cloneDeep(schedule[key])
      }
    },
    setPatientCheckList (state, mutationList) {
      let currentIndex = state.userInfo.lv - 1
      if (currentIndex < 0) return false

      for (let index = 0; index < mutationList.length; index++) {
        let check = state.schedule.level[currentIndex].lv_up_targets.find(
          v => v.type === mutationList[index].type
        )

        if (check === null) continue

        check.progress = mutationList[index].progress
      }
    },
    // 重置 state
    RESET_STATE: (state) => {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    setUserId (context, id) {
      context.commit('setUserId', id)
    },
    async setUserInfo (context, id) {
      context.commit('setUserId', id)

      try {
        let response = await GET_PATIENT_PROFILE(id)

        let genderStr = [i18n.t('formItemName.female'), i18n.t('formItemName.male')]
        let affectiveSide = response.data.affectiveSide == null ? 'left' : response.data.affectiveSide[0]
        let userInfo = {
          id: id || '',
          name: response.data.name || '',
          birthdate: response.data.birthday || '',
          age: moment().diff(moment(response.data.birthday), 'year') || 0,
          avatar: response.data.avatar || '',
          gender: genderStr[response.data.gender] || '',
          managements: response.data.managements || {},
          affectiveSide: affectiveSide,
          isLock: response.data.isLock || false,
          lockTime: response.data.lockTime || 0,
          lv: response.data.lv || 0,
          timezone: response.data.timezone || DEFAULT_TIMEZONE,
          finishRateThreshold: response.data.finishRateThreshold || 50,
          isRental: response.data.isRental,
          isRentalEnd: calcRentalStatus(response.data.endTime),
          startTime: response.data.startTime || 0,
          endTime: response.data.endTime || 0,
          scheduleStarted: response.data.scheduleStarted,
          scheduleId: response.data.scheduleId,
          medicalPersonnel: {
            id: response.data.medicalPersonnel[0].id,
            name: response.data.medicalPersonnel[0].name,
            avatar: response.data.medicalPersonnel[0].avatar,
            type: response.data.medicalPersonnel[0].type
          },
          device: {
            deviceName: response.data.device.deviceName,
            lotNumber: response.data.device.lotNumber,
            mac: response.data.device.mac,
            pin: response.data.device.pin,
            recycleDuration: response.data.device.recycleDuration,
            rentalEndTime: response.data.device.rentalEndTime,
            rentalStatus: response.data.device.rentalStatus,
            sn: response.data.device.sn,
            token: response.data.device.token
          },
          painFeedbackLockId: response.data.painFeedbackLockId
        }

        context.commit('setUserInfo', userInfo)
        context.commit('setOperationFromAPI', response.data)

        return response
      } catch (error) {
        let userInfo = {
          id: '',
          name: 'Error',
          birthdate: '1911/1/1',
          age: 0,
          avatar: '',
          gender: '-',
          managements: {},
          affectiveSide: '',
          isLock: false,
          lockTime: 0,
          lv: -1,
          timezone: DEFAULT_TIMEZONE,
          finishRateThreshold: 50,
          isRental: false,
          isRentalEnd: false,
          startTime: 0,
          endTime: 0,
          scheduleStarted: false,
          scheduleId: null,
          medicalPersonnel: {
            id: '',
            name: '',
            avatar: '',
            type: 0
          },
          device: {
            deviceName: '',
            lotNumber: '',
            mac: '',
            pin: '',
            recycleDuration: 0,
            rentalEndTime: 0,
            rentalStatus: 0,
            sn: '',
            token: ''
          },
          painFeedbackLockId: ''
        }

        context.commit('setUserInfo', userInfo)
        throw error
      }
    },
    async setRecord (context, id) {
      try {
        let response = await GET_ALL_RECORD(id)

        let record = {
          id: id,
          loadedTime: new Date().getTime(),
          data: response.data
        }
        context.commit('setRecord', record)
      } catch (error) {
        throw error
      }
    },
    async setScore (context, id) {
      try {
        let response = await GET_KSQ_LIST(id)

        let score = {
          id: id,
          loadedTime: new Date().getTime(),
          scoreList: response.data
        }

        context.commit('setScore', score)
      } catch (error) {
        throw error
      }
    }
  }
}

function calcRentalStatus (endTime) {
  if (endTime === 0) {
    return false
  }
  const today = new Date().getTime()
  return today > endTime
}



// WEBPACK FOOTER //
// ./src/stores/modules/patient.js